class CoreUserPermission
{
    // Admin privileges, other permissions are not checked
    static ROOT = 'core_user.*';

    // Enabled flag: if not present, access denied on any operation. Not required for root
    static _ENABLED = 'core_user._m';

    // Scope: all core users across all workspaces
    static ACCESS_SCOPE_ALL = 'core_user.access.scope.all';

    // Scope: only self if caller has 'core' type
    static ACCESS_SCOPE_SELF = 'core_user.access.scope.self';

    // Can access unverified users
    static ACCESS_UNVERIFIED = 'core_user.access.unverified';

    // Can access shutdown users
    static ACCESS_SHUTDOWN = 'core_user.access.shutdown';

    // Can create new core users
    static CREATE = 'core_user.create';

    // Can manage occupancy settings of the core user
    static OCCUPANCY_MANAGE = 'core_user.occupancy.manage';

    // Can update main core user info
    static INFO_UPDATE = 'core_user.info.update';

    // Can manually update core user email
    static EMAIL_UPDATE_MANUAL = 'core_user.email.update.manual';

    // Can use UserEmailChange flow to update email
    static EMAIL_UPDATE_FLOW = 'core_user.email.update.flow';

    // Can manually manage core user verification status
    static VERIFICATION_MANAGE = 'core_user.verification.manage';

    // Can initiate and use user verification flow
    static VERIFICATION_FLOW = 'core_user.verification.flow';

    // Can shut down core user
    static SHUTDOWN = 'core_user.shutdown';

    // Can set up Google auth
    static AUTH_GOOGLE_SETUP = 'core_user.auth.google.setup';

    // Can remove Google auth
    static AUTH_GOOGLE_REMOVE = 'core_user.auth.google.remove';

    // Can set up password auth
    static AUTH_PASSWORD_SETUP = 'core_user.auth.password.setup';

    // Can remove password auth
    static AUTH_PASSWORD_REMOVE = 'core_user.auth.password.remove';

    // Can update password with confirmation
    static AUTH_PASSWORD_UPDATE = 'core_user.auth.password.update';

    // Can manually apply new password without confirmation
    static AUTH_PASSWORD_UPDATE_FORCED = 'core_user.auth.password.update.forced';

    // Can manage auth role of core user
    static AUTH_ROLE_MANAGE = 'core_user.auth_role.manage';
}

export default CoreUserPermission;
